import { render, staticRenderFns } from "./UserProfileCard.vue?vue&type=template&id=0488deac&scoped=true&"
import script from "./UserProfileCard.vue?vue&type=script&lang=js&"
export * from "./UserProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileCard.vue?vue&type=style&index=0&id=0488deac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488deac",
  null
  
)

export default component.exports